import React from "react";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function WeatherBackground(props) {
  return (
    <div className="WeatherBackground">
      <h1 className="title-city">{props.data.city}</h1>
      <div className="row mt-4">
        <div className="col m-2 weatherInfo">
          <WeatherInfo data={props.data} />
        </div>
        <div className="col m-2 forecastInfo">
          <WeatherForecast coordinates={props.data.coordinates} />
        </div>
      </div>
    </div>
  );
}
